import { PlainTextTable } from ".";
import { LANGTYPE_CT, LANGTYPE_EN, LangType } from "../../LanguageContext";

export class Entries {
  entriesTable?: PlainTextTable;

  constructor(data?: IEntries){
    this.entriesTable = new PlainTextTable(data?.entries?.value)
  }
}

export class EntriesTable {
  horseTitle?: string;
  trainerTitle?: string;
  records?: {
    horse_en?: string;
    horse_ch?: string;
    trainer_en?: string;
    trainer_ch?: string;
  }[]

  constructor(langType: LangType, textTbl?: PlainTextTable){
    switch(langType){
      case LANGTYPE_EN: // PRJ2555-706: must be 2 columns for eng format
        this.horseTitle = textTbl?.headers?.[0]
        this.trainerTitle = textTbl?.headers?.[1]
        textTbl?.contents?.byRow?.map((r: string[])=>{
          const record = {
            horse_en: r[0] || '',
            trainer_en: r[1] || '',
          }
          if (record && !this.records){
            this.records = []
          }
          this.records?.push(record);
        })
        break;
      case LANGTYPE_CT: // PRJ2555-706: must be 4 columns for chi format
        this.horseTitle = textTbl?.headers?.[0]
        this.trainerTitle = textTbl?.headers?.[2]
        textTbl?.contents?.byRow?.map((r: string[])=>{
          const record = {
            horse_en: r[0] || '',
            horse_ch: r[1] || '',
            trainer_en: r[2] || '',
            trainer_ch: r[3] || '',
          }
          if (record && !this.records){
            this.records = []
          }
          this.records?.push(record);
        })
        break;
    }
  }
}